import React from 'react';
import { IconWarningExclamation } from './Icons/WarningExclamation';
import { IconGreenCheck } from './Icons/GreenCheck';

/**
 * @param  {string} message
 * @param  {string} type
 */
const Alert = ({ info }) => {
    const { message, type } = info;
    return (
        <div id='warnNotice' className={`alert ${type}-alert` }>
            <span className='alert-icon'>
            {type === 'success' ? <IconGreenCheck className='icon-check' height='16' width='16'/> : <IconWarningExclamation height='16' width='16' className='icon'/>}{' '}
            </span>
            <p  className="alert-text" data-testid="alert-component-text" dangerouslySetInnerHTML={{ __html: message }} />
        </div>
    );
};

export default Alert;
